import(/* webpackMode: "eager" */ "/codebuild/output/src3569558602/src/doctor-dashboard/app/global-error.tsx");
